import { useQuery } from "@tanstack/react-query";
import { getAllPermissions } from "../api/permission";

export const useGetPermissions = () => {
  return useQuery({
    queryKey: ["permissions"],
    queryFn: () => getAllPermissions(),
  });
};
